//React
import React from "react";
import {
  Link
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//add
import moment from 'moment';
import { scroller, Element } from 'react-scroll';
//Action
import * as chargeAction from '../action/chargeAction';
import * as helpAction from '../action/helpAction';

//Material-ui
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
//Dialog
import DialogConfirm from './DialogConfirm';
//Img
import bitcashIcon from '../img/bitcash/bitcash_icon.png';
import imgConveni7 from '../img/conveni/conveni_7.jpg';
import imgConveniL from '../img/conveni/conveni_L.jpg';
import imgConveniM from '../img/conveni/conveni_M.jpg';
import imgConveniF from '../img/conveni/conveni_F.jpg';
import imgConveniK from '../img/conveni/conveni_K.jpg';
import imgConveniD from '../img/conveni/conveni_D.jpg';
import imgConveniS from '../img/conveni/conveni_S.jpg';

//Icon
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

//JSON
var bitcashPlanItem = require('../data/bitcashPlanItem');


class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      price: null,
      days: null,
      hiraganaId: '',
      hiraganaIdError: '',
      validateErrorType: null,
      validateErrorComment: '',
      bcs_id: null,
      noProofPerson: false,
    }
	}

  _select(days, price) {
    if (this.props.my.proof.person !== 1) {
      this.setState({noProofPerson: true });
    }
    else {
      this.setState({days: days, price: price, });
      scroller.scrollTo('submit_block', {
        delay: 300,
        duration: 300,
        smooth: true,
        offset: -50,
      })
    }
  }

  _hiraganaIdEdit(value) {
    this.setState({hiraganaId: value});

    let errorComment;

    if (value.length > 0) {
      if (value.match(/^[ぁ-ん]+$/) == null) {
    		errorComment = 'ひらがな以外の文字が含まれています';
    	}
      else if (value.length < 16 || value.length > 16) {
    		errorComment = '16文字で入力してください';
    	}
    }

  	if (errorComment) {
  		this.setState({hiraganaIdError: errorComment});
  	}
  	else {
      this.setState({hiraganaIdError: ''});
    }
  }

  _validate() {
    this.props.bitcashValidate(this.state.hiraganaId, this.state.price, (data) => {
      if (data.bool) {
        this.setState({bcs_id: data.bcs_id});
      }
      else {
        if (data.type === 'balance') {
          this.setState({hiraganaIdError: (
            <div>
              {data.comment}<br/>
              <a
                href="https://bitcash.jp/bitcash/merge"
                target="_blank"
                rel="noreferrer noopener"
              >
                <u>残高をまとめる場合はこちら</u>
              </a><br/>
              <a
                href="https://bitcash.jp/bitcash/balance"
                target="_blank"
                rel="noreferrer noopener"
              >
                <u>残高を確認する</u>
              </a>
            </div>
          )});
        }
        else {
          this.setState({hiraganaIdError: data.comment});
        }
      }
    })
  }

  _settle() {
    this.props.bitcashSettle(this.state.bcs_id, this.state.price, this.state.days, () => {
      this.props.history.push('/setting/charged/');
    })
  }

  render() {
    let startDate = moment.unix(this.props.my.setting.chargeStart);
    let endDate =  moment.unix(this.props.my.setting.chargeEnd);
    let nowDate =  moment();

    return (
      <div>
        <div style={{padding:'10px'}}>

          <h2 align='center'>ビットキャッシュとは？</h2>
          <div style={{padding:'5px',color:'#666'}}>
            <Grid container  justifyContent="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
              <Grid item>
                <img
                  src={ imgConveni7 }
                  style={{height:'40px',width:'auto'}}
                  alt=''
                />
              </Grid>
              <Grid item>
                <img
                  src={ imgConveniL }
                  style={{height:'40px',width:'auto'}}
                  alt=''
                />
              </Grid>
              <Grid item>
                <img
                  src={ imgConveniM }
                  style={{height:'40px',width:'auto'}}
                  alt=''
                />
              </Grid>
              <Grid item>
                <img
                  src={ imgConveniF }
                  style={{height:'40px',width:'auto'}}
                  alt=''
                />
              </Grid>
              <Grid item>
                <img
                  src={ imgConveniK }
                  style={{height:'40px',width:'auto'}}
                  alt=''
                />
              </Grid>
              <Grid item>
                <img
                  src={ imgConveniD }
                  style={{height:'40px',width:'auto'}}
                  alt=''
                />
              </Grid>
              <Grid item>
                <img
                  src={ imgConveniK }
                  style={{height:'40px',width:'auto'}}
                  alt=''
                />
              </Grid>
              <Grid item>
                <img
                  src={ imgConveniS }
                  style={{height:'40px',width:'auto'}}
                  alt=''
                />
              </Grid>

            </Grid>
            <div style={{padding:'5px',color:'#666'}}>
              コンビニで購入いただけるプリペイドカードです。<br />
              購入後にひらがなIDを入力いただくとすぐに有料サービスがご利用いただけます。
            </div>
          </div>
        </div>
        <div style={{padding:'10px'}}>
          <h2 align='center'>ビットキャッシュ決済方法</h2>
          <div style={{padding:'5px',color:'#666'}}>
            <ul style={{paddingLeft:'20px'}}>
              <li>購入いただく料金プランを選んでください。</li>
              <li>コンビニ等でプラン料金分のビットキャッシュを購入してください。</li>
              <li>購入したビットキャッシュに記載されている「ひらがなID」をこのページに入力してください。</li>
            </ul>
          </div>
        </div>

        <div style={{padding:'10px'}}>
          <h2 align='center'>ビットキャッシュの購入方法</h2>

          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'center'
            }}
          >
            <div style={{padding:'5px'}}>
              <div style={{display:'inline-block', background:'#FFF', padding:'10px', 	borderRadius:'8px'}}>
                <img
                  src={ bitcashIcon }
                  style={{height:'80px',width:'auto'}}
                  alt=''
                />
              </div>
            </div>

            <div style={{padding:'5px',color:'#666'}}>
              <div>
              プリペイドカード販売コーナーのこのマークのビットキャッシュカードを購入いただくか、
              または店舗の端末からも購入いただけます。</div>

            </div>
          </div>

          <div align='center' style={{padding:'5px'}}>
            <a
              href="http://bitcash.jp/docs/purchase/index?sv=1"
              target="_blank"
              rel="noreferrer noopener"
            >
              <Button
                color="primary"
                variant={ "outlined" }
                style={{fontSize:'1.1em'}}
              >
                店舗別の詳しい購入方法は<br/>ビットキャッシュ公式ページ<br/>からご確認ください
              </Button>
            </a>
          </div>
          <div align='center' style={{padding:'5px'}}>
            <a
              href="https://bitcash.jp/bitcash/merge"
              target="_blank"
              rel="noreferrer noopener"
            >
              <u>コチラで残高をまとめることもできます</u>
            </a>
          </div>
        </div>


        <div style={{padding:'10px'}}>
          <h2 align='center'>プランを選択してください</h2>

          {
            (nowDate.isBetween(startDate , endDate) === true) && (
              <div style={{padding:'10px'}}>お客様のアカウントは有料サービス中の為、有料サービスの終了日はプランの日数分延長されます。</div>
            )
          }


          <div style={{maxWidth:'400px', margin:'auto'}}>
            {
              bitcashPlanItem.map( (value, index) => {

                let checked;
                if (this.state.days === value.days) {
                  checked = true;
                }
                else {
                  checked = false;
                }

                let borderColor;
                let textColor;
                let iconType;
                if (index === 0) {
                  borderColor = '#FFE7C2';
                  textColor = '#FF9900';
                  iconType = 'orange_icon';
                }
                else if (index === 1) {
                  borderColor = '#A6BDD5';
                  textColor = '#0D58A6';
                  iconType = 'blue_icon';
                }
                else if (index === 2) {
                  borderColor = '#E7B0D0';
                  textColor = '#CB0077';
                  iconType = 'red_icon';
                }

                let startDate = moment.unix(this.props.my.setting.chargeStart);
                let endDate =  moment.unix(this.props.my.setting.chargeEnd);
                let nowDate =  moment();
                let newEndDateComp;

                if (nowDate.isBetween(startDate , endDate )) {
                  newEndDateComp = (
                    <div style={{marginTop:'5px'}}>
                      <div style={{fontSize:'0.9em', color:'#666'}}>有料サービス</div>
                      <div style={{fontSize:'1.1em', color:'#333'}}>
                         { endDate.add(value.days, 'days').format('YYYY年MM月DD日') }まで
                      </div>
                    </div>
                  )
                }
                else {
                  newEndDateComp = (
                    <div style={{marginTop:'5px'}}>
                      <div style={{fontSize:'0.9em', color:'#666'}}>有料サービス</div>
                      <div style={{fontSize:'1.1em', color:'#333'}}>
                          有料サービス { nowDate.add((value.days - 1), 'days').format('YYYY年MM月DD日') }まで
                      </div>
                    </div>
                  )
                }

                return (
                  <div key={index}>
                    <Box className='button_chargePlan round12' boxShadow={2}
                      style={{
                        color: '#333',
                        borderTop: 'solid 6px ' + borderColor,
                        margin: '15px',
                        cursor: 'pointer',
                      }}
                      onClick={ () => this._select(value.days, value.price) }
                    >
                      <div style={{padding:'15px'}}>
                        <div
                          style={{
                            display:'flex',
                            alignItems:'center',
                            justifyContent:'space-between',
                          }}
                        >
                          <div style={{fontSize:'1.4em', fontWeight:500, color:textColor}}>{ value.ja }</div>
                          <div>
                            <Checkbox
                              checked={checked}
                              style ={{color: textColor}}
                            />
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              display:'flex',
                              flexDirection:'row',
                              alignItems:'center',
                              justifyContent:'space-between',
                            }}
                          >
                            <div>
                              <span style={{fontSize:'1.8em', fontWeight:'bold', color:textColor}}>¥{ value.price }</span>
                              <span style={{fontSize:'1em', color:textColor}}>(税込)</span>
                            </div>

                            {
                              (value.discount > 0) && (
                                <div><span className={iconType}>¥{value.discount}お得</span></div>
                              )
                            }
                          </div>
                        </div>
                        {
                          (value.convert > 0) && (
                            <div>30日換算で¥{ value.convert }</div>
                          )
                        }
                        {
                          newEndDateComp
                        }
                      </div>
                    </Box>
                  </div>
                )
              })
            }
          </div>
        </div>


        <Element name='submit_block'>
          {
            (this.state.days) && (
              <div>

                <div align='center'>
                  <ArrowDropDownIcon style={{color:'#ccc',fontSize:'4em'}}/>
                </div>

                <h2 align='center'>購入したビットキャッシュに<br/>記載してある「ひらがなID」を<br/>入力してください</h2>
                <div style={{maxWidth:'400px', margin:'auto'}}>
                  <div  style={{padding:'10px'}}>

                    <div style={{padding:'5px'}}>
                      <div align='left'>ひらがな16文字</div>
                      <input
                        type="text"
                        value={ this.state.hiraganaId }
                        style={{fontSize:'1.1em'}}
                        className="input_blue round12"
                        onChange={ (e) => this._hiraganaIdEdit(e.target.value) }
                      />
                      <div align='right'>{this.state.hiraganaId.length}文字</div>
                      <div style={{color:'red'}}>{this.state.hiraganaIdError}</div>
                    </div>

                    <div align='center' style={{padding:'5px'}}>
                      <Button
                        variant="contained"
                        color='primary'
                        onClick={ () => this._validate() }
                        style={{fontSize:'1.2em'}}
                        disabled={ (this.state.hiraganaIdError.length > 0 || this.state.hiraganaId.length === 0) ? true : false }
                      >
                        ビットキャッシュで決済する
                      </Button>
                    </div>
                    <div align='right' style={{marginTop:'15px'}}>
                      <a
                        href="http://bitcash.jp/docs_jp/tri?act=terms/legal_notices_about_settlement"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        <u>資金決済法に基づく表示</u>
                      </a>
                    </div>
                  </div>

                </div>
                <DialogConfirm
                  open={ (this.state.bcs_id) ? true : false }
                  title={'ビットキャッシュ決済'}
                  content={ this.state.days + '日プラン(¥' + this.state.price + ')の決済を行ってもいいですか？'}
                  apply={ () => this._settle() }
                  close={ () => this.setState({bcs_id: null}) }
                />
              </div>
            )
          }
        </Element>
        <div style={{padding:'5px'}}>
          <div style={{padding:'10px',fontSize:'0.9em',color:'#666'}}>
            ※ 提供サービスの性質上、クーリングオフの適応はありません。<br/>
            また有料サービスの期間中に退会された場合も日割り計算による料金の払い戻しはありません。
          </div>
        </div>
        <DialogConfirm
          open={ this.state.noProofPerson }
          title={'本人証明が未提出'}
          content={(
            <div>
              <h2 align='center'>有料サービスのお申し込みには<br/>本人証明が必要です</h2>
              <div align='center' style={{padding:'10px'}}>
                <Link to='/my/proof/person'>
                  <Button
                    variant="contained"
                    color='primary'
                  >
                    本人証明を申請する
                  </Button>
                </Link>
              </div>
            </div>
          )}
          close={ () => this.setState({noProofPerson: false}) }
        />
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...chargeAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
